export default "__VITE_ASSET__BW$UtMHw__"